import(/* webpackMode: "eager" */ "/home/runner/_work/core/core/apps/watch-modern/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/core/core/apps/watch-modern/src/components/Datadog/ErrorBoundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/core/core/apps/watch-modern/src/components/Datadog/Init/Init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/core/core/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
